"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeVerificationOutcome = exports.IncomeReportDisplayStatus = exports.IncomeComputationResultVisibilityQuery = void 0;
var IncomeComputationResultVisibilityQuery;
(function (IncomeComputationResultVisibilityQuery) {
    IncomeComputationResultVisibilityQuery["AllNotRetracted"] = "AllNotRetracted";
    IncomeComputationResultVisibilityQuery["PublishedOnly"] = "PublishedOnly";
})(IncomeComputationResultVisibilityQuery || (exports.IncomeComputationResultVisibilityQuery = IncomeComputationResultVisibilityQuery = {}));
var IncomeReportDisplayStatus;
(function (IncomeReportDisplayStatus) {
    IncomeReportDisplayStatus["ACCEPTED_USED"] = "ACCEPTED_USED";
    IncomeReportDisplayStatus["ACCEPTED_NOT_USED"] = "ACCEPTED_NOT_USED";
    IncomeReportDisplayStatus["REJECTED"] = "REJECTED";
    IncomeReportDisplayStatus["IN_PROGRESS"] = "IN_PROGRESS";
    IncomeReportDisplayStatus["NOT_NEEDED"] = "NOT_NEEDED";
    IncomeReportDisplayStatus["UNKNOWN"] = "UNKNOWN";
})(IncomeReportDisplayStatus || (exports.IncomeReportDisplayStatus = IncomeReportDisplayStatus = {}));
var IncomeVerificationOutcome;
(function (IncomeVerificationOutcome) {
    IncomeVerificationOutcome["FULLY_VERIFIED"] = "FULLY_VERIFIED";
    IncomeVerificationOutcome["PARTIALLY_VERIFIED"] = "PARTIALLY_VERIFIED";
    IncomeVerificationOutcome["INSUFFICIENT"] = "INSUFFICIENT";
})(IncomeVerificationOutcome || (exports.IncomeVerificationOutcome = IncomeVerificationOutcome = {}));
